import { Validators } from '@angular/forms';
import { uniqBy } from 'lodash';
import { LEGAL_JURISDICTIONS } from 'src/app/shared/consts/legal-juristictions.const';
import { TableCols } from '../interfaces/static-data';

export const CONTACTS: TableCols[] = [
  {
    key: 'deskId',
    displayValue: 'Desk',
    type: 'select',
    validators: [Validators.required],
  },
  {
    key: 'name',
    displayValue: 'Name',
    validators: [Validators.required],
  },
  {
    key: 'email',
    displayValue: 'Email',
    validators: [Validators.required, Validators.email],
  },
  {
    key: 'cognitoUsername',
    displayValue: 'Cognito Username',
  },
  {
    key: 'location',
    displayValue: 'Location',
    type: 'select',
    items: uniqBy(LEGAL_JURISDICTIONS, 'id')
      .sort((a, b) => a.displayValue.localeCompare(b.displayValue))
      .map(({ id, displayValue }) => ({
        id,
        displayValue,
      })),
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  }
];
